import { BuilderComponent } from '@builder.io/react'

import { BUILDER_ADS_MODEL, BUILDER_ADS_QUERY } from '@/config/builder'

import type { BlogLayoutProps } from '../BlogLayout'

export function AdsBottom({ adsBottom }: Pick<BlogLayoutProps, 'adsBottom'>) {
  return (
    <BuilderComponent
      model={BUILDER_ADS_MODEL}
      content={adsBottom}
      options={{ query: BUILDER_ADS_QUERY.bottom }}
    />
  )
}
